import { useState, useRef, useEffect } from "react";

export default function DraggableProgressBar({ value = 50, onChange }) {
  const [isDragging, setIsDragging] = useState(false);
  const trackRef = useRef(null);

  const updateProgress = (e) => {
    if (!trackRef.current) return;

    const rect = trackRef.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(e.clientX - rect.left, rect.width));
    const newProgress = Math.min(100, Math.max(0, (x / rect.width) * 100));
    onChange?.(newProgress);
    // 🔥 send value to parent
  };

  const handleMouseDown = (e) => {
    setIsDragging(true);
    updateProgress(e);
  };

  useEffect(() => {
    if (!isDragging) return;

    const handleMove = (e) => updateProgress(e);
    const handleUp = () => setIsDragging(false);

    document.addEventListener("mousemove", handleMove);
    document.addEventListener("mouseup", handleUp);

    return () => {
      document.removeEventListener("mousemove", handleMove);
      document.removeEventListener("mouseup", handleUp);
    };
  }, [isDragging]);

  return (
    <div className="relative w-full min-w-[100px]">
      <div
        ref={trackRef}
        onClick={updateProgress}
        className="relative h-1 bg-[#c1c1c1] rounded-full cursor-pointer"
      >
        {/* Fill */}
        <div
          className="absolute h-full bg-[linear-gradient(263deg,#b46cff,#ff5fd1)] rounded-full"
          style={{ width: `${value}%` }}
        />

        {/* Thumb */}
        <div
          onMouseDown={handleMouseDown}
          className="absolute top-1/2 w-[16px] h-[16px] bg-[#000] rounded-full cursor-grab active:cursor-grabbing shadow-lg"
          style={{
            left: `${value}%`,
            transform: "translate(-50%, -50%)",
          }}
        />
      </div>
    </div>
  );
}
